import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stateCodeToName' })
export class StateCodeToNamePipe implements PipeTransform {
    transform(stateCode: string): string {
        if (!stateCode) {
            return '';
        }

        const input = String(stateCode).trim();
        const normalizedName = input.toUpperCase();

        switch (normalizedName) {
            case 'AB':
                return 'Alberta';
            case 'AG':
                return 'Aguascalientes';
            case 'AL':
                return 'Alabama';
            case 'AK':
                return 'Alaska';
            case 'AR':
                return 'Arkansas';
            case 'AZ':
                return 'Arizona';
            case 'BC':
                return 'British Columbia';
            case 'BN':
                return 'Baja California';
            case 'BS':
                return 'Baja California Sur';
            case 'CA':
                return 'California';
            case 'CH':
                return 'Coahuila';
            case 'CI':
                return 'Chihuahua';
            case 'CL':
                return 'Colima';
            case 'CM':
                return 'Campeche';
            case 'CO':
                return 'Colorado';
            case 'CS':
                return 'Chiapas';
            case 'CT':
                return 'Connecticut';
            case 'DC':
                return 'District Of Columbia';
            case 'DE':
                return 'Delaware';
            case 'DG':
                return 'Durango';
            case 'DF':
                return 'Distrito Federal';
            case 'FL':
                return 'Florida';
            case 'GA':
                return 'Georgia';
            case 'GR':
                return 'Guerrero';
            case 'GJ':
                return 'Guanajuato';
            case 'HD':
            case 'HG':
                return 'Hidalgo';
            case 'HI':
                return 'Hawaii';
            case 'IA':
                return 'Iowa';
            case 'ID':
                return 'Idaho';
            case 'IL':
                return 'Illinois';
            case 'IN':
                return 'Indiana';
            case 'JA':
                return 'Jalisco';
            case 'KS':
                return 'Kansas';
            case 'KY':
                return 'Kentucky';
            case 'LA':
                return 'Louisiana';
            case 'MA':
                return 'Massachusetts';
            case 'MB':
                return 'Manitoba';
            case 'MC':
                return 'Michoacan';
            case 'MD':
                return 'Maryland';
            case 'ME':
                return 'Maine';
            case 'MI':
                return 'Michigan';
            case 'MN':
                return 'Minnesota';
            case 'MO':
                return 'Missouri';
            case 'MR':
                return 'Morelos';
            case 'MS':
                return 'Mississippi';
            case 'MT':
                return 'Montana';
            case 'MX':
                return 'Mexico (State of)';
            case 'NA':
                return 'Nayarit';
            case 'NB':
                return 'New Brunswick';
            case 'NC':
                return 'North Carolina';
            case 'ND':
                return 'North Dakota';
            case 'NE':
                return 'Nebraska';
            case 'NF':
                return 'Newfoundland';
            case 'NH':
                return 'New Hampshire';
            case 'NJ':
                return 'New Jersey';
            case 'NL':
                return 'Nuevo Leon';
            case 'NM':
                return 'New Mexico';
            case 'NS':
                return 'Nova Scotia';
            case 'NT':
                return 'Northwest Territories';
            case 'NY':
                return 'New York';
            case 'NU':
                return 'Nunavut';
            case 'NV':
                return 'Nevada';
            case 'OA':
                return 'Oaxaca';
            case 'OH':
                return 'Ohio';
            case 'OK':
                return 'Oklahoma';
            case 'ON':
                return 'Ontario';
            case 'OR':
                return 'Oregon';
            case 'PA':
                return 'Pennsylvania';
            case 'PE':
                return 'Prince Edward Island';
            case 'PU':
                return 'Puebla';
            case 'QC':
                return 'Quebec';
            case 'QE':
                return 'Queretaro';
            case 'QR':
                return 'Quintana Roo';
            case 'QT':
                return 'Queretaro';
            case 'RI':
                return 'Rhode Island';
            case 'SC':
                return 'South Carolina';
            case 'SD':
                return 'South Dakota';
            case 'SI':
                return 'Sinaloa';
            case 'SK':
                return 'Saskatchewan';
            case 'SL':
                return 'San Luis Potosi';
            case 'SO':
                return 'Sonora';
            case 'TA':
                return 'Tamaulipas';
            case 'TB':
                return 'Tabasco';
            case 'TL':
                return 'Tlaxcala';
            case 'TM':
                return 'Tamaulipas';
            case 'TN':
                return 'Tennessee';
            case 'TX':
                return 'Texas';
            case 'UT':
                return 'Utah';
            case 'VA':
                return 'Virginia';
            case 'VC':
            case 'VE':
                return 'Veracruz';
            case 'VT':
                return 'Vermont';
            case 'WA':
                return 'Washington';
            case 'WI':
                return 'Wisconsin';
            case 'WV':
                return 'West Virginia';
            case 'WY':
                return 'Wyoming';
            case 'YT':
                return 'Yukon Territory';
            case 'YU':
                return 'Yucatan';
            case 'ZA':
                return 'Zacatecas';
            default:
                return input;
        }
    }
}
